import React from "react";
import App from "./App";
import { apiUrlFront, URL_APP, URL_BKI } from "./constants/URL";

export default function AppWithRsaFrames() {
  const renderMenu = () => {
    const urlTrazabilidad = `${URL_BKI.REDIRECT}?vista=${URL_APP.TRAZABILIDAD}&vistaError=${URL_APP.ERROR}`;
    const urlTablaProperties = `${URL_BKI.REDIRECT}?vista=${URL_APP.PROPIETATS}&vistaError=${URL_APP.ERROR}`;
    const urlMetataula = `${apiUrlFront()}${URL_APP.METATAULA}`;

    return (
      <>
        <ol>
          <li>
            <a href={urlTrazabilidad}>TRAZABILIDAD</a>
          </li>
          <li>
            <a href={urlTablaProperties}>TablaProperties</a>
          </li>
          <li>
            <a href={urlMetataula}>MetaTaula</a>
          </li>
        </ol>
      </>
    );
  };

  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      <iframe
        src="https://pre.salut.gencat.cat/pls/gsa/GSAPKMEN.escr_logo_html_vertical_aux?p_aplicacio=BKINT&p_usuari=am14_19-n2&p_form_inici=BKINTFH003&p_perfil=ADMINISTRADOR"
        name="logo"
        style={{ height: "100px", border: "none" }}
        title="logo"
        scrolling="no"
      ></iframe>
      <div style={{ display: "flex", flexGrow: 1 }}>
        {/* <iframe
          src="https://pre.salut.gencat.cat/pls/gsa/GSAPKMEN.escriure_menu_html_vertical?p_aplicacio=BKINT&p_usuari=am14_19-n2&p_perfil=ADMINISTRADOR"
          name="menu"
          style={{ width: "25%", border: "none" }}
          title="menu"
          scrolling="auto"
        ></iframe> */}
        <div
          style={{ width: "25%", border: "none" }}
          title="oculto"
          scrolling="no"
        >
          {renderMenu()}
        </div>
        <div style={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
          <iframe
            src="https://pre.salut.gencat.cat/pls/gsa/GSAPKMEN.html_nul"
            name="oculto"
            style={{ height: "1%", border: "none" }}
            title="oculto"
            scrolling="no"
          ></iframe>
          <div style={{ height: "80%", width: "80%" }}>
            <App />
          </div>
        </div>
      </div>
    </div>
  );
}
